import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { axiosInstance } from '@/lib/axios'

export type BasicDriver = {
  fullName: string
  id: number
  isActive: boolean
  name?: string
  surname?: string
  email?: string | null
  phoneNumber?: string | null
  nationality?: { name?: string } | null
  firstContractStartDate?: string | null
}

type Props = {
  companyId: string | undefined
  enabled?: boolean
}

/**
 * Fetches the compact "basic drivers" list used by pickers, the side panel
 * and the grouped contracts table. Cached for 5 minutes.
 */
export function useQueryBasicDrivers({ companyId, enabled = true }: Props) {
  return useQuery<BasicDriver[]>({
    queryKey: ['basicDrivers', String(companyId ?? '')],
    enabled: enabled && !!companyId,
    staleTime: MINUTE_IN_MS * 5,
    queryFn: async () => {
      const res = await axiosInstance.get(`/api/${companyId}/drivers/basic`)
      return res.data ?? []
    },
  })
}
